import { useNavigate } from '@/hooks/useNavigate';
import React, { useEffect, memo, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { stringToReact } from '@/utils/helpers';
import { CustomHtmlBlockProps } from './CustomHtmlBlock.interface';
import useStyles from './CustomHtmlBlock.styles';

const CustomHtmlBlock = (props: Br.PropsWithContentButtons<CustomHtmlBlockProps>) => {
  const { headField, stylesField, contentField, scriptsField, datalayerVariant, contentButtons } =
    props;
  const classes = useStyles({});
  const contentRef = React.useRef<HTMLDivElement>(null);
  const { navigate } = useNavigate();
  // TODO: use sanitizeHtml to sanitize contentField and headField; and limit the tags and attributes
  const headContent = useMemo(
    () => (headField ? stringToReact(headField, 'head') : null),
    [headField],
  );

  useEffect(() => {
    if (!contentRef?.current) return () => {};
    if (!scriptsField) return () => {};

    try {
      // eslint-disable-next-line
      const executeScript: any = new Function(`return ${scriptsField}`)();
      const remove = executeScript({ target: contentRef.current, navigate });

      return () => remove();
    } catch (error) {
      console.error('Error while executing script', error);
    }

    return () => {};
  }, [navigate, scriptsField]);

  return (
    <>
      <section
        className={classes.root}
        data-testid="qa-custom-html-block-component"
        data-datalayer-position="custom_html_block"
        data-datalayer-variant={datalayerVariant}
      >
        {headField && <Helmet>{headContent}</Helmet>}
        {contentButtons?.content}
        {stylesField && (
          <Helmet>
            <style>{stylesField}</style>
          </Helmet>
        )}
        <div
          ref={contentRef}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: contentField || '' }}
        />
      </section>
    </>
  );
};

export default memo(CustomHtmlBlock);
